import { DynamicForm } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../../constants";
import { useContactUs } from "../../Pages.hook";

const ContactData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { openToast } = useNotification();
  const navigate = useNavigate();
  const query = useQuery();

  const {
    data: pagesDataById,
    isLoading: isLoadingPagesById,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  const { data: contactUsData, isLoading: isLoadingContactUs, refetch: refetchContactUs } = useContactUs();

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }

    refetchContactUs();
  }, [query.get("editId"), query.get("id")]);

  const contactDataFields = {
    initialValues: {
      title: pagesDataById?.payload ? decodeHTML(pagesDataById?.payload?.title) : decodeHTML(contactUsData?.[0]?.title),
      field_page_title_ms: pagesDataById?.payload
        ? decodeHTML(pagesDataById?.payload?.field_page_title_ms)
        : decodeHTML(contactUsData?.[0]?.field_page_title_ms),
      field_page_title_zh: pagesDataById?.payload
        ? decodeHTML(pagesDataById?.payload?.field_page_title_zh)
        : decodeHTML(contactUsData?.[0]?.field_page_title_zh),
      body: pagesDataById?.payload ? decodeHTML(pagesDataById?.payload?.body) : decodeHTML(contactUsData?.[0]?.body),
      field_common_malay_description: pagesDataById?.payload
        ? decodeHTML(pagesDataById?.payload?.field_common_malay_description)
        : decodeHTML(contactUsData?.[0]?.field_common_malay_description),
      field_common_mandarin_descriptio: pagesDataById?.payload
        ? decodeHTML(pagesDataById?.payload?.field_common_mandarin_descriptio)
        : decodeHTML(contactUsData?.[0]?.field_common_mandarin_descriptio),
    },
    fields: fields.contactDetails,
  };

  const onSubmit = async (
    formdata: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const payload = {
      action: action,
      method: method,
      module: "Pages",
      subModule: "aboutEraman_contactUs_contactDetails",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: pagesDataById?.payload?.id || contactUsData?.[0]?.id,
        }),
        ...formdata,
      },
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status === "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status === "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status === "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingContactUs || isLoadingPagesById}
      config={contactDataFields}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${eramanHost}/api/contact-center-page-data-update-api/${pagesDataById?.payload?.id || contactUsData?.[0]?.id}`,
          "UPDATE",
          "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
    />
  );
};

export default ContactData;
